import { Grid, GridProps } from '@mui/material';
import React from 'react';

// Create a wrapper component for the Material UI Grid
type MuiGridProps = GridProps & {
  item?: boolean;
  container?: boolean;
  xs?: number | boolean;
  sm?: number | boolean;
  md?: number | boolean;
  lg?: number | boolean;
  xl?: number | boolean;
};

const MuiGrid: React.FC<MuiGridProps> = (props) => {
  return <Grid {...props} />;
};

export default MuiGrid;